import React, { useState } from "react";
import { SectionHeading } from "./SectionHeading";
import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { Reveal, RevealStagger, RevealItem } from "./Reveal";

const faqs = [
  {
    q: "Do I need to install an app?",
    a: "No. SlotBook runs in any browser on any device. Your clients book through a link — no downloads required — and you manage everything from your phone, tablet or computer.",
  },
  {
    q: "Can I import my existing clients?",
    a: "Yes. You can import your client list from a spreadsheet or your current software in minutes, including contact details, notes and visit history.",
  },
  {
    q: "How do deposits and payments work?",
    a: "You can choose how much clients pay upfront — from a small deposit to full payment. Payments are processed securely by Stripe and transferred to your bank account according to your Stripe payout schedule.",
  },
  {
    q: "Is there a lock-in contract?",
    a: "Never. All plans are month-to-month and you can upgrade, downgrade or cancel at any time. The 30-days free trial requires no credit card.",
  },
  {
    q: "Will the booking page match my brand?",
    a: "Absolutely. Add your logo, colours, services and photos to create a booking page that feels like a natural extension of your business.",
  },
  {
    q: "Do you offer support?",
    a: "Yes — our Australian-based support team is available by chat and email, Studio and Enterprise plans include priority support.",
  },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-2xl border border-border bg-card/60 transition-colors hover:bg-card">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 p-5 text-left"
        aria-expanded={open}
      >
        <span className="text-base font-medium text-foreground">{q}</span>
        <Plus
          className={cn(
            "size-5 shrink-0 text-brand transition-transform duration-300",
            open && "rotate-45",
          )}
        />
      </button>
      <div
        className={cn(
          "grid transition-all duration-300 ease-out",
          open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        )}
      >
        <div className="overflow-hidden">
          <p className="px-5 pb-5 text-pretty leading-relaxed text-muted-foreground">
            {a}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-24 px-4 py-12 sm:py-16">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <SectionHeading
            eyebrow="FAQ"
            title="Questions, answered"
            description="Everything you need to know before getting started."
          />
        </Reveal>
        <RevealStagger className="mt-10 flex flex-col gap-3" stagger={0.06}>
          {faqs.map((f) => (
            <RevealItem key={f.q} y={14}>
              <FaqItem {...f} />
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
